import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeUntil'
})
export class TimeUntilPipe implements PipeTransform {
  transform(value: Date): string {
    if (!value) return '';
    
    const diff = value.getTime() - Date.now();
    if (diff <= 0) return 'now';

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    
    if (minutes < 1) {
      return `${seconds}s`;
    } else if (minutes < 60) {
      return `${minutes}m`;
    } else {
      const hours = Math.floor(minutes / 60);
      return `${hours}h ${minutes % 60}m`;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/time-until.pipe.ts